import { matchPath } from "react-router-dom";
import { can } from "./moduleAccess";

/**
 * Route → required moduleAccess action for SCREEN access only.
 * Shared lookup APIs (get-suppliers / get-all-customers / get-users) used inside
 * other modules' forms are NOT gated here — see utils/lookupAccess.js.
 * More specific paths (with :id) should be listed; first match wins.
 */
const ROUTE_ACCESS_RULES = [
  // Supplier Master
  { path: "/supplyMasterAdd", module: "supply_master", action: "create" },
  { path: "/supplyMasterImport", module: "supply_master", action: "create" },
  { path: "/supplyMasterEdit/:id", module: "supply_master", action: "update" },
  { path: "/supplyMasterView/:id", module: "supply_master", action: "view" },
  { path: "/supplyMaster", module: "supply_master", action: "view" },

  // Purchase Request
  {
    path: "/procurementTrackerAdd",
    module: "procurement_tracker",
    action: "create",
  },
  {
    path: "/procurementTrackerImport",
    module: "procurement_tracker",
    action: "update",
    orActions: ["create"],
  },
  {
    path: "/procurementTrackerEdit/:id",
    module: "procurement_tracker",
    action: "update",
  },
  {
    path: "/procurementView/:id",
    module: "procurement_tracker",
    action: "view",
  },
  {
    path: "/procurementTracker",
    module: "procurement_tracker",
    action: "view",
  },

  // Logistics RFQ
  {
    path: "/logisticsRfqCreate/:id",
    module: "logistics",
    action: "update",
  },
  { path: "/logisticsRfqCreate", module: "logistics", action: "create" },
  { path: "/logisticsRfqView/:id", module: "logistics", action: "view" },
  {
    path: "/logisticsRfqComparison/:id",
    module: "logistics",
    action: "view",
  },
  { path: "/logisticsRfq", module: "logistics", action: "view" },

  // RFQ — /rfqCreate/:id is edit
  { path: "/rfqCreate/:id", module: "rfq", action: "update" },
  { path: "/rfqCreate", module: "rfq", action: "create" },
  { path: "/rfqView/:id", module: "rfq", action: "view" },
  { path: "/rfqComparison/:id", module: "rfq", action: "view" },
  { path: "/rfq", module: "rfq", action: "view" },

   // LRFQ — /lrfqCreate/:id is edit
  { path: "/logisticsRfqCreate/:id", module: "logistics", action: "update" },
  { path: "/logisticsRfqCreate", module: "logistics", action: "create" },
  { path: "/logisticsRfqView/:id", module: "logistics", action: "view" },
  { path: "/logisticsRfqComparison/:id", module: "logistics", action: "view" },
  { path: "/logisticsRfq", module: "logistics", action: "view" },


  // Supplier RFQ portal
  { path: "/rfqSupplierView/:id", module: "supplier_rfq", action: "view" },
  { path: "/rfqSupplierList", module: "supplier_rfq", action: "view" },

    // Supplier PO portal
  { path: "/poSupplierView/:id", module: "supplier_po", action: "view" },
  { path: "/poSupplierList", module: "supplier_po", action: "view" },

    // Supplier GI portal
  { path: "/giSupplierView/:id", module: "supplier_gi", action: "view" },
  { path: "/giSupplierList", module: "supplier_gi", action: "view" },


   // Customer SQ portal
  { path: "/customerSalesQuoteList", module: "customer_sq", action: "view" },
  { path: "/customerSalesQuoteView/:id", module: "customer_sq", action: "view" },

  // Customer SO portal
  { path: "/customerSalesOrderList", module: "customer_so", action: "view" },
  { path: "/customerSalesOrderView/:id", module: "customer_so", action: "view" },

  // PO
  { path: "/poCreate", module: "po", action: "create" },
  { path: "/poEdit/:id", module: "po", action: "update" },
  { path: "/poView/:id", module: "po", action: "view" },
  { path: "/po", module: "po", action: "view" },

  // Price List
  { path: "/priceTrackerAdd", module: "price_tracker", action: "create" },
  { path: "/priceTrackerEdit/:id", module: "price_tracker", action: "update" },
  { path: "/priceTrackerView/:id", module: "price_tracker", action: "view" },
  { path: "/priceTracker", module: "price_tracker", action: "view" },

  // Customer Master
  { path: "/customerMasterAdd", module: "customer_master", action: "create" },
  {
    path: "/customerMasterEdit/:id",
    module: "customer_master",
    action: "update",
  },
  { path: "/customerMasterView/:id", module: "customer_master", action: "view" },
  { path: "/customerMaster", module: "customer_master", action: "view" },

  // Sales Tracker
  { path: "/salesTrackerAdd", module: "sales_tracker", action: "create" },
  { path: "/salesTrackerEdit/:id", module: "sales_tracker", action: "update" },
  { path: "/salesTrackerView/:id", module: "sales_tracker", action: "view" },
  { path: "/salesTracker", module: "sales_tracker", action: "view" },

  // Sales Quotes
  { path: "/salesQuotesAdd", module: "sales_quotes", action: "create" },
  { path: "/salesQuotesEdit/:id", module: "sales_quotes", action: "update" },
  { path: "/salesQuotesView/:id", module: "sales_quotes", action: "view" },
  { path: "/salesQuotes", module: "sales_quotes", action: "view" },

  // Sales Order
  { path: "/salesOrderCreate/:id", module: "sales_order", action: "update" },
  { path: "/salesOrderCreate", module: "sales_order", action: "create" },
  { path: "/salesOrderEdit/:id", module: "sales_order", action: "update" },
  { path: "/salesOrderView/:id", module: "sales_order", action: "view" },
  { path: "/salesOrderImport", module: "sales_order", action: "create" },
  { path: "/salesOrder", module: "sales_order", action: "view" },

  // Sales Approval
  { path: "/poApproveView/:id", module: "sales_approval", action: "view" },
  { path: "/poApprove", module: "sales_approval", action: "view" },

  // E-Catalogue
  { path: "/ecatalogueEdit/:id", module: "ecatalogue", action: "update" },
  { path: "/ecatalogueView/:id", module: "ecatalogue", action: "view" },
  { path: "/ecatalogue", module: "ecatalogue", action: "view" },

  // Inventory
  { path: "/inventory", module: "inventory_management", action: "view" },

  // Goods Inwards
  { path: "/goodsInwardsCreate", module: "goods_inwards", action: "create" },
  { path: "/goodsInwardsEdit/:id", module: "goods_inwards", action: "update" },
  { path: "/goodsInwardsView/:id", module: "goods_inwards", action: "view" },
  { path: "/goodsInwards", module: "goods_inwards", action: "view" },

  // Goods Outwards
  { path: "/goodsOutwardsCreate", module: "goods_outwards", action: "create" },
  {
    path: "/goodsOutwardsEdit/:id",
    module: "goods_outwards",
    action: "update",
  },
  { path: "/goodsOutwardsView/:id", module: "goods_outwards", action: "view" },
  { path: "/goodsOutwards", module: "goods_outwards", action: "view" },

  // SO Converter
  { path: "/soConverter", module: "so_converter", action: "view" },
  { path: "/soValidate", module: "so_converter", action: "create" },
  { path: "/sodata", module: "so_converter", action: "view" },

  // Customer Order Report
  // Import uses flag permission tracker_update_import (not create CRUD)
  {
    path: "/trackerUpdateAdd",
    module: "tracker_update",
    action: "create",
    orPermission: "tracker_update_import",
  },
  { path: "/trackerAdd", module: "tracker_update", action: "create" },
  { path: "/trackerEdit/:id", module: "tracker_update", action: "update" },
  { path: "/trackerView/:id", module: "tracker_update", action: "view" },
  { path: "/trackerUpdate", module: "tracker_update", action: "view" },

  // Payment Tracker
  { path: "/paymentTrackerAdd", module: "payment_tracker", action: "create" },
  {
    path: "/paymentTrackerEdit/:id",
    module: "payment_tracker",
    action: "update",
  },
  { path: "/paymentView/:id", module: "payment_tracker", action: "view" },
  { path: "/paymentTracker", module: "payment_tracker", action: "view" },

  // Freight Tracker
  {
    path: "/frightTrackerCreate",
    module: "freight_tracker",
    action: "create",
  },
  {
    path: "/frightTrackerEdit/:id",
    module: "freight_tracker",
    action: "update",
  },
  { path: "/frightTrackerView/:id", module: "freight_tracker", action: "view" },
  { path: "/frightTracker", module: "freight_tracker", action: "view" },

  // Tasks
  { path: "/taskAdd", module: "task_management", action: "create" },
  { path: "/taskEdit/:id", module: "task_management", action: "update" },
  { path: "/taskView/:id", module: "task_management", action: "view" },
  { path: "/task", module: "task_management", action: "view" },

  // Master Data
  { path: "/category", module: "category_management", action: "view" },
  { path: "/subcategory", module: "subcategory_management", action: "view" },
  { path: "/materialCreate", module: "material_management", action: "create" },
  { path: "/materialEdit/:id", module: "material_management", action: "update" },
  { path: "/materialView/:id", module: "material_management", action: "view" },
  { path: "/material", module: "material_management", action: "view" },
  { path: "/unit", module: "unit_management", action: "view" },
  { path: "/attribute", module: "attribute_management", action: "view" },

  // AI Search
  { path: "/aiChat", module: "ai_chat", action: "view" },

  // Users / Roles
  { path: "/UserAdd", module: "user_management", action: "create" },
  { path: "/userEdit/:id", module: "user_management", action: "update" },
  { path: "/userView/:id", module: "user_management", action: "view" },
  { path: "/user", module: "user_management", action: "view" },
  { path: "/roles/add", module: "role_management", action: "create" },
  { path: "/roles/edit/:id", module: "role_management", action: "update" },
  { path: "/roles", module: "role_management", action: "view" },
  { path: "/business", module: "business_management", action: "view" },
];

/** Paths that never require moduleAccess checks */
const ALWAYS_ALLOWED = new Set(["/profile", "/dashboard"]);

const SUPERADMIN_ALLOWED_MODULES = new Set(["user_management", "business_management"]);


const SUPERADMIN_ONLY_MODULES = new Set(["business_management"]);

function resolveRole(userOrAccess) {
  const role =
    (userOrAccess &&
      typeof userOrAccess === "object" &&
      !Array.isArray(userOrAccess) &&
      userOrAccess.role) ||
    localStorage.getItem("role") ||
    "";
  return String(role).trim().toLowerCase();
}

/**
 * Resolve required { module, action } for a pathname, or null if unmapped.
 */
export function getRouteAccessRequirement(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (!path || ALWAYS_ALLOWED.has(path)) return null;

  for (const rule of ROUTE_ACCESS_RULES) {
    const match = matchPath({ path: rule.path, end: true }, path);
    if (match) {
      return {
        module: rule.module,
        action: rule.action,
        orPermission: rule.orPermission || null,
        orActions: Array.isArray(rule.orActions) ? rule.orActions : null,
      };
    }
  }
  return null;
}

/**
 * @returns {boolean} true if the current user may open this path
 */
export function canAccessPath(userOrAccess, pathname) {
  const path = String(pathname || "").split("?")[0];
  const role = resolveRole(userOrAccess);

  if (role === "superadmin") {
    if (ALWAYS_ALLOWED.has(path)) return true;
    const requirement = getRouteAccessRequirement(pathname);
    if (!requirement) return false;
    return SUPERADMIN_ALLOWED_MODULES.has(requirement.module);
  }

  const requirement = getRouteAccessRequirement(pathname);
  if (!requirement) return true;

  if (SUPERADMIN_ONLY_MODULES.has(requirement.module)) return false;

  if (can(userOrAccess, requirement.module, requirement.action)) return true;

  if (
    Array.isArray(requirement.orActions) &&
    requirement.orActions.some((action) =>
      can(userOrAccess, requirement.module, action),
    )
  ) {
    return true;
  }

  // Flag permissions (saved on role.permissions, not as moduleAccess modules)
  if (requirement.orPermission) {
    if (role === "admin") return true;

    let permissions = [];
    if (
      userOrAccess &&
      typeof userOrAccess === "object" &&
      !Array.isArray(userOrAccess) &&
      Array.isArray(userOrAccess.permissions)
    ) {
      permissions = userOrAccess.permissions;
    } else {
      try {
        permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
      } catch {
        permissions = [];
      }
    }
    return permissions.includes(requirement.orPermission);
  }

  return false;
}